import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CollectionPassport } from "@/components/Passport";
import { BookOpen, Globe, BookMarked } from "lucide-react";

export default function CollectionPassportPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/collection/map").then(({ data }) => setData(data)).catch(() => setData(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
      <div className="mb-6">
        <p className="font-tech text-xs uppercase tracking-widest brand-text">Stamps earned</p>
        <h1 className="font-display text-4xl font-bold">My Collection Passport</h1>
      </div>

      <div className="flex gap-2 mb-8 flex-wrap">
        <Link to="/collection" data-testid="tab-collection" className="px-4 py-2 rounded-full text-sm font-semibold surface border inline-flex items-center gap-2"><BookOpen className="w-4 h-4" /> My Collection</Link>
        <Link to="/collection/map" data-testid="tab-map" className="px-4 py-2 rounded-full text-sm font-semibold surface border inline-flex items-center gap-2"><Globe className="w-4 h-4" /> World Map</Link>
        <span data-testid="tab-passport-active" className="px-4 py-2 rounded-full text-sm font-semibold text-white inline-flex items-center gap-2" style={{ background: "var(--brand)" }}><BookMarked className="w-4 h-4" /> Passport</span>
      </div>

      {data === false ? (
        <p className="text-muted-page">Could not load your passport.</p>
      ) : !data ? (
        <div className="text-center py-20 text-muted-page animate-pulse font-tech">Loading passport…</div>
      ) : (
        <CollectionPassport data={data} />
      )}
    </div>
  );
}
